<!-- firewall-dashboard.component.html -->
<div class="dashboard-wrapper">
	<div *ngIf="isLoading" class="loading-overlay">
		<div class="loading-spinner"></div>
	</div>
	<div class="modal-backdrop" (click)="toggleAll()" *ngIf="showPopup"></div>
	<div class="modal-container image-modal-container" *ngIf="isImageModalOpen">
		<h2 class="modal-title">Image: {{this.orderCurrent.part.partNumber}}</h2>
		<div class="image-modal-content">
			<img [src]="this.orderCurrent.partImage" alt="Enlarged Part Image" />
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="toggleImage()">Close</button>
		</div>
	</div>
	<div class="modal-container" *ngIf="showFirewall">
		<h2 class="modal-title">Please Enter Final OK/NOK Count</h2>
		<form (submit)="submitFirewall()" class="modal-form">
			<label>
				OK
				<input type="number" [(ngModel)]="quantityEntered" name="ok" required />
			</label>

			<label>
				NOK
				<input type="number" [(ngModel)]="quantityNok" name="nok" required />
			</label>

			<div class="modal-actions">
				<button type="submit" class="btn-submit">Submit</button>
			</div>
		</form>
	</div>
	<!-- IMAGE PROMPT MODAL -->
	<div class="modal-container image-prompt-modal" *ngIf="showImagePrompt">
		<div class="image-prompt-header">
			<div class="image-prompt-icon"><i class="fas fa-camera"></i></div>
			<div>
				<h2 class="modal-title image-prompt-title">Add a Photo?</h2>
				<p class="image-prompt-subtitle">Optionally attach an image to this firewall log</p>
			</div>
		</div>
		<div class="modal-actions" style="margin-top: 24px;">
			<button type="button" class="btn-cancel" (click)="skipImageUpload()">Skip</button>
			<button type="button" class="btn-submit" (click)="openImageCapture()">
				<i class="fas fa-camera" style="margin-right: 8px;"></i>Add Photo
			</button>
		</div>
	</div>

	<!-- IMAGE CAPTURE MODAL -->
	<div class="modal-container image-capture-modal" *ngIf="showImageCapture">
		<h2 class="modal-title">Take or Upload Photo</h2>
		<div class="image-capture-body">
			<label class="image-capture-label">
				<input type="file" accept="image/*" capture="environment" (change)="onImageSelected($event)" class="image-file-input" />
				<div class="image-capture-placeholder" *ngIf="!capturedImagePreview">
					<i class="fas fa-camera"></i>
					<span>Tap to take photo or choose from library</span>
				</div>
				<img *ngIf="capturedImagePreview" [src]="capturedImagePreview" class="image-capture-preview" alt="Captured image" />
			</label>
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="skipImageUpload()">Skip</button>
			<button type="button" class="btn-submit" (click)="uploadFirewallImage()" [disabled]="!capturedImageFile || isLoading">
				<i class="fas fa-upload" style="margin-right: 8px;"></i>Upload &amp; Submit
			</button>
		</div>
	</div>

	<!-- NOK DETAILS MODAL -->
	<div class="modal-container nok-modal" *ngIf="showNok">
		<div class="nok-modal-header">
			<div class="nok-modal-icon"><i class="fas fa-exclamation-triangle"></i></div>
			<div>
				<h2 class="modal-title nok-modal-title">NOK Parts Detected</h2>
				<p class="nok-modal-subtitle">Please provide details about the failed parts</p>
			</div>
		</div>
		<hr class="nok-divider" />
		<div class="modal-form">
			<label>
				Area of Issue
				<dx-select-box class="input-override" [(ngModel)]="selectedArea" [dataSource]="areasOfIssue" placeholder="Select an area..." style="margin-top: 8px;"></dx-select-box>
			</label>
			<label>
				Failure Reason
				<dx-select-box class="input-override" [(ngModel)]="selectedReason" [dataSource]="nokReasons" displayExpr="reason" valueExpr="id" placeholder="Select a reason..." style="margin-top: 8px;"></dx-select-box>
			</label>
			<div class="nok-toggles">
				<label class="nok-toggle-card">
					<span class="nok-toggle-text">Is Production Issue</span>
					<input type="checkbox" [(ngModel)]="selectedProduction" name="isProduction" />
					<span class="nok-toggle-switch"></span>
				</label>
				<label class="nok-toggle-card">
					<span class="nok-toggle-text">Pre Paint</span>
					<input type="checkbox" [(ngModel)]="selectedPaint" name="prePaint" />
					<span class="nok-toggle-switch"></span>
				</label>
			</div>
			<div class="modal-actions">
				<button type="button" class="btn-cancel" (click)="cancelNok()">Cancel</button>
				<button type="button" class="btn-submit" (click)="submitFirewallLog()">Submit</button>
			</div>
		</div>
	</div>

	<div id="openMachineRequest" class="modal-container" *ngIf="showOpenMachineRequestForm">
		<h2 class="modal-title">Select Type of Request</h2>
		<div class="modal-form">
			<label>
				Reason <dx-select-box class="input-override" [(ngModel)]="selectedMachineRequestType" [value]="selectedMachineRequestType" id="selectedMachineRequestType" [dataSource]="machineRequestTypes" displayExpr="name" valueExpr="id" placeholder="Select a reason..." style="margin-top: 8px;"></dx-select-box>
			</label>
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="cancelMachineRequest()">Cancel</button>
			<button type="button" class="btn-submit" (click)="submitMachineRequest()">Submit</button>
		</div>
	</div>
	<div id="openSupervisorRequest" class="modal-container" *ngIf="showOpenSupervisorRequestForm">
		<h2 class="modal-title">Select Reason for Supervisor</h2>
		<div class="modal-form">
			<label>
				Reason <dx-select-box [(ngModel)]="selectedSupervisorRequestReasonId" [value]="selectedSupervisorRequestReasonId" id="selectedSupervisorRequestReasonId" [dataSource]="supervisorRequestReasons" displayExpr="reason" valueExpr="id" placeholder="Select a reason..." style="margin-top: 8px;"></dx-select-box>
			</label>
			<div class="modal-actions">
				<button type="button" class="btn-cancel" (click)="cancelSupervisorRequest()">Cancel</button>
				<button type="button" class="btn-submit" (click)="submitSupervisorRequest()">Submit</button>
			</div>
		</div>
	</div>
	<div class="qs-modal-backdrop" *ngIf="showCloseSupervisorRequestFormLogin">
		<div class="qs-modal">
			<div class="qs-modal-body">
				<div class="qs-pin-logo">
					<i class="fas fa-lock"></i>
				</div>
				<h3 class="qs-result-title">Supervisor PIN</h3>
				<p class="qs-pin-subtitle">Enter your supervisor PIN to continue</p>
				<!-- PIN dots -->
				<div class="qs-pin-dots">
					<div class="qs-pin-dot" *ngFor="let _ of pinSlots; let i = index" [ngClass]="{ 'qs-pin-dot-filled': i < supervisorPin.length }"></div>
				</div>
				<div class="qs-pin-error" *ngIf="pinError">{{ pinError }}</div>
				<!-- Keypad -->
				<div class="qs-pin-keypad">
					<div class="qs-pin-row">
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('1')">1</button>
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('2')">2</button>
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('3')">3</button>
					</div>
					<div class="qs-pin-row">
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('4')">4</button>
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('5')">5</button>
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('6')">6</button>
					</div>
					<div class="qs-pin-row">
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('7')">7</button>
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('8')">8</button>
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('9')">9</button>
					</div>
					<div class="qs-pin-row">
						<button type="button" class="qs-key-btn qs-key-btn-back" (click)="onPinBackspace()" [disabled]="supervisorPin.length === 0">
							<i class="fas fa-backspace"></i>
						</button>
						<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onPinDigit('0')">0</button>
						<button type="button" class="qs-key-btn qs-key-btn-ok" (click)="onPinOk()" [disabled]="!canSubmitPin() || isLoading">
							<i class="fas fa-check"></i>
						</button>
					</div>
				</div>
				<div class="qs-modal-actions-bottom">
					<button type="button" class="qs-secondary-btn-wide" (click)="cancelCloseSupervisorRequest()">Cancel</button>
				</div>
			</div>
		</div>
	</div>
	<div id="closeSupervisorRequest" class="modal-container" *ngIf="showCloseSupervisorRequestForm">
		<h2 class="modal-title">Enter Closing Comments</h2>
		<div class="modal-form">
			<label>
				Comments
				<dx-text-box [(ngModel)]="closeSupervisorRequestDto.closingComments" placeholder="Enter closing comments..." style="margin-top: 8px;"></dx-text-box>
			</label>
			<div class="modal-actions">
				<button type="button" class="btn-cancel" (click)="cancelCloseSupervisorRequest()">Cancel</button>
				<button type="button" class="btn-submit" (click)="submitCloseSupervisorRequest()">Close Request</button>
			</div>
		</div>
	</div>

	<!-- ADD TO ALLOCATION MODAL -->
	<div class="modal-container" *ngIf="showAllocate">
		<h2 class="modal-title">Enter Work Order Id and Quantity</h2>

		<form class="modal-form">
			<label>
				Work Order Id
				<input type="text" [(ngModel)]="allocationWo" name="workOrder" required />
				<br />
				<button class="btn-cancel" style="width:100%; margin-top:20px;" (click)="toggleScan()">Scan Work Order</button>
			</label>

			<label>
				Quantity
				<input type="text" [(ngModel)]="allocationQty" name="qty" required />
			</label>

			<div class="modal-actions">
				<button type="submit" class="btn-submit" (click)="assignToAllocations(allocationWo,allocationQty)">Submit</button>
				<button type="button" class="btn-cancel" (click)="toggleAllocate()">Cancel</button>
			</div>
		</form>
	</div>

	<!-- SCAN MODAL -->
	<div class="modal-container" *ngIf="showScan">
		<h2 class="modal-title">Scan Work Order</h2>
		<div class="image-modal-content">
			<zxing-scanner #scanner [formats]="[allowedFormats]" [device]="selectedDevice" (camerasFound)="cameraFound($event)" (camerasNotFound)="camerasNotFound()" (scanSuccess)="onScanSuccess($event)" ></zxing-scanner>
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="toggleScan()">Cancel</button>
		</div>
	</div>

	<!-- CHANGE ORDER SCAN MODAL -->
	<div class="modal-container" *ngIf="showChangeOrderModal">
		<h2 class="modal-title">Change Order</h2>		
		<form class="modal-form">
			<table>
				<thead>
					<tr>
						<th>Part</th>
						<th>Qty</th>
						<th>Date Req.</th>
						<th>Operator</th>
						<th>Select</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let order of ordersToday">
						<td>{{order.partNumber}}</td>
						<td>{{order.quantityOrdered}}</td>
						<td>{{formatDate(order.dateRequired)}}</td>
						<td>{{order.operatorFullName}}</td>
						<td><button type="button" class="btn-change" (click)="setCurrentOrder(order.id, order.type)">Select</button></td>
					</tr>
				</tbody>
			</table>
			<div class="modal-actions">
				<button type="button" class="btn-cancel" (click)="closeChangeOrderModal()">Cancel</button>
			</div>
		</form>
	</div>

	<!-- CHECK WORK ORDER SCAN MODAL -->
	<div class="modal-container" *ngIf="showCheckWorkOrderScan">
		<h2 class="modal-title">Scan Work Order</h2>
		<div class="image-modal-content">
			<zxing-scanner [formats]="[allowedFormats]" [device]="selectedDevice" (camerasFound)="cameraFound($event)" (camerasNotFound)="camerasNotFound()" (scanSuccess)="onCheckWoScanSuccess($event)"></zxing-scanner>
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="closeCheckWorkOrderScan()">Cancel</button>
		</div>
	</div>

	<!-- CHECK WORK ORDER RESULTS MODAL -->
	<div class="modal-container check-wo-modal" *ngIf="showCheckWorkOrderModal">
		<div class="check-wo-status-bar" [style.background-color]="getCheckWorkOrderStatusBar().color">
			{{ getCheckWorkOrderStatusBar().text }}
		</div>
		<div class="check-wo-body">
			<div class="check-wo-row">
				<span class="check-wo-label">Work Order ID</span>
				<span class="check-wo-value">{{ checkWorkOrderDetails?.id }}</span>
			</div>
			<div class="check-wo-row">
				<span class="check-wo-label">Part Number</span>
				<span class="check-wo-value">{{ checkWorkOrderDetails?.part?.partNumber }}</span>
			</div>
			<div class="check-wo-row">
				<span class="check-wo-label">Client Name</span>
				<span class="check-wo-value">{{ checkWorkOrderDetails?.clientName || checkWorkOrderDetails?.part?.client?.name }}</span>
			</div>
			<div class="check-wo-row">
				<span class="check-wo-label">WO Quantity</span>
				<span class="check-wo-value">{{ checkWorkOrderDetails?.quantity }}</span>
			</div>
			<div class="check-wo-row">
				<span class="check-wo-label">Quantity Available</span>
				<span class="check-wo-value" [class.check-wo-value-red]="getCheckWorkOrderQtyAvailable() <= 0">
					{{ getCheckWorkOrderQtyAvailable() }}
				</span>
			</div>
			<div class="modal-actions" style="margin-top: 16px;">
				<button type="button" class="btn-cancel" (click)="closeCheckWorkOrderModal()">Close</button>
			</div>
		</div>
	</div>

	<!-- Change Mode Modal -->
	<div class="modal-container" *ngIf="showMode">
		<h2 class="modal-title">Please Enter Final OK/NOK Count</h2>
		<div class="row">
			<div class="card-grid">
				<div class="dashboard-card" *ngFor="let card of statuses" (click)="changeMode(card.id)"
					style="border-left: 10px solid {{renderStatusColorForModal(card.id)}}">
					<div class="icon-wrapper" style="background-color:{{renderStatusColorForModal(card.id)}}">
						<i class="fas fa-tools"></i>
					</div>
					<div class="card-title">{{ card.name }}</div>
				</div>
			</div>
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="toggleMode()">Cancel</button>
		</div>
	</div>
	<!-- Header -->
	<div class="dashboard-header" style="border-left:solid 50px {{this.currentStatusColor}}">
		<div class="header-left">
			<h1>{{this.machine.cellNumber}} ({{this.machine.department}})</h1>
			<div *ngIf="this.orderCurrent?.operatorId != null" class="subheading">
				{{this.orderCurrent?.operatorFullName}}
			</div>
			<div *ngIf="this.orderCurrent?.operatorId == null" class="subheading blink_me warning">No Operator
				Assigned
			</div>
		</div>
		<div class="header-status">
			<span>Status:</span>
			<div class="status-indicator" style="background-color:{{this.currentStatusColor}}">
				{{this.currentStatusText}}</div>
		</div>
	</div>

	<div class="dashboard-content-full" *ngIf="orderCurrent === undefined || orderCurrent === null">
		<div class="no-workorder-panel">
			<i class="fas fa-box-open"></i>
			<p>No Work Order assigned to this cell</p>
		</div>
	</div>

	<!-- Main Content -->
	<div class="dashboard-content" *ngIf="orderCurrent != undefined">
		<section class="production-info">
			<div *ngIf="this.orderCurrent.orderType == 0" class="info-card quantity-progress" style="margin-bottom:24px;">
				<div class="label">QUANTITY COMPLETED / REQUIRED</div>
				<div class="value">{{this.quantityPicked}}/{{this.orderCurrent.quantityOrdered}}</div>
				<div class="progress-bar">
					<div class="progress-fill"
						style="width:{{(this.quantityPicked/this.orderCurrent.quantityOrdered) * 100}}%;">
					</div>
				</div>
			</div>
			<div *ngIf="this.orderCurrent.orderType == 10" class="info-card quantity-progress" style="margin-bottom:24px;">
				<div class="label">SPOT ORDER QUANTITY</div>
				<div class="value">{{this.orderCurrent.quantityOrdered}}</div>
			</div>
			<div class="oknok-row">
				<div class="info-card ok-count-card">
					<div class="label">OK</div>
					<div class="value">{{totalOk}}</div>
				</div>
				<div class="info-card nok-count-card">
					<div class="label">NOK</div>
					<div class="value">{{totalNok}}</div>
				</div>
			</div>
			<div class="columns">
				<div class="info-column">
					<div class="info-card part-number">
						<div class="label">PART NUMBER</div>
						<div class="value">{{this.orderCurrent.partNumber}}</div>
					</div>
					<div class="info-card pack-factor">
						<div class="label">PACK FACTOR</div>
						<div class="value">{{this.orderCurrent.part.packFactorExternal}}</div>
					</div>
					<div class="info-card client-info">
						<div class="label">CLIENT</div>
						<div class="value">{{this.orderCurrent.clientName}}</div>
					</div>
				</div>
				<div class="info-column">
					<div class="info-card date-required-info">
						<div class="label">DATE REQUIRED</div>
						<div class="value">{{ getOrderDateValue() }}</div>
					</div>
					<div class="info-card packaging-info">
						<div class="label">PACKAGING</div>
						<div class="value">{{this.orderCurrent.part.packagingExternal.name}}</div>
					</div>
					<div *ngIf="this.orderCurrent.orderType == 0" class="info-card" [class.allocation-number]="this.orderCurrent.allocationId == null" [class.blink_me]="this.orderCurrent.allocationId == null" [class.operator-info]="this.orderCurrent.allocationId > 0">
						<div class="label">ALLOCATION NUMBER</div>
						<div *ngIf="this.orderCurrent.allocationId > 0" class="value">{{this.orderCurrent.allocationId}}</div>
						<div *ngIf="this.orderCurrent.allocationId == null" class="value">No Allocation</div>
					</div>
				</div>
			</div>
		</section>

		<section class="right-panel">
			<!-- Check / change Work Order Button -->
			<div class="check-wo-btn-row">
				<button *ngIf="this.ordersToday.length > 1" class="btn-check-wo" (click)="openChangeOrder()">
					<i class="fas fa-sync"></i> Change Order
				</button>
				<button class="btn-check-wo" (click)="openCheckWorkOrder()">
					<i class="fas fa-search"></i> Check Work Order
				</button>
			</div>
			<!-- Image -->
			<div class="part-image">
				<div class="image-box">
					<img [src]="this.orderCurrent.partImage" alt="part image" (click)="toggleImage()" />
				</div>
			</div>

			<!-- Controls -->
			<div class="controls">
				<div class="control-grid">
					<!-- Create allocation or add to allocation-->
					<button class="control-btn green" (click)="createAllocationForEdiOrder(this.orderCurrent.id)" *ngIf="(currentStatus == 10 && this.orderCurrent.operatorId !== null) && this.orderCurrent.allocationId === null && this.orderCurrent.orderType == 0">
						<!-- CREATE ALLOCATION -->
						<i class="fas fa-plus"></i>
					</button>
					<button class="control-btn green" (click)="toggleAllocate()" *ngIf="(currentStatus == 10 && this.orderCurrent.operatorId !== null) && this.orderCurrent.allocationId !== null && this.orderCurrent.orderType == 0">
						<!-- ADD TO ALLOCATION -->
						<i class="fas fa-plus"></i>
					</button>
					<button class="control-btn gray" *ngIf="currentStatus != 10 || this.orderCurrent.operatorId === null || this.orderCurrent.orderType == 10">
						<!-- DEAD -->
						<i class="fas fa-plus"></i>
					</button>
					<!-- Pick Order -->
					<button class="control-btn yellow" (click)="setToPicked()" *ngIf="currentStatus == 10 && this.orderCurrent.operatorId !== null && this.orderCurrent.allocationId !== null && this.quantityPicked > 0 && this.quantityPicked != this.orderCurrent.quantityOrdered && this.orderCurrent.orderType == 0">
						<!-- COMPLETE NOT FULL QUANTITY -->
						<i class="fas fa-check-circle"></i>
					</button>
						<button class="control-btn green" (click)="setToPicked()" *ngIf="this.orderCurrent.orderType == 10 || (currentStatus == 10 && this.orderCurrent.operatorId !== null && this.orderCurrent.allocationId !== null && this.quantityPicked == this.orderCurrent.quantityOrdered && this.orderCurrent.orderType == 0)">
						<!-- COMPLETE FULL QUANTITY -->
						<i class="fas fa-check-circle"></i>
					</button>
					<button class="control-btn gray" *ngIf="this.orderCurrent.orderType == 0 && (currentStatus != 10 || this.orderCurrent.operatorId === null || this.orderCurrent.allocationId === null || this.quantityPicked == 0)">
						<!-- DEAD -->
						<i class="fas fa-check-circle"></i>
					</button>
					<!-- Supervisor Request on Machine-->
					<button class="control-btn orange" (click)="openSupervisorRequest()" *ngIf="currentStatus!=100 && openSupervisorRequestId === null">
						<i class="fas fa-engine-warning"></i>
					</button>
					<button class="control-btn blue" (click)="closeSupervisorRequest()" *ngIf="openSupervisorRequestId !== null">
						<i class="fas fa-engine-warning"></i>
					</button>
					<button class="control-btn gray" *ngIf="currentStatus==100">
						<!-- DEAD -->
						<i class="fas fa-engine-warning"></i>
					</button>
					<!-- Machine Request?-->
					<button class="control-btn pink" (click)="openMachineRequestModal()" *ngIf="currentStatus!=100">
						<i class="fas fa-box"></i>
					</button>
					<button class="control-btn gray" (click)="openMachineRequestModal()" *ngIf="currentStatus==100">
						<!-- DEAD -->
						<i class="fas fa-box"></i>
					</button>
					<!-- Machine Status -->
					<button class="control-btn purple" (click)="toggleMode()" *ngIf="currentStatus!=100">
						<i class="fas fa-tools"></i>
					</button>
					<button class="control-btn gray" (click)="toggleMode()" *ngIf="currentStatus==100">
						<!-- DEAD -->
						<i class="fas fa-tools"></i>
					</button>
					<!-- Reload Info -->
					<button class="control-btn blue" (click)="reloadPage();">
						<i class="fas fa-redo-alt"></i>
					</button>
				</div>
			</div>
		</section>
	</div>
</div>